//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ActionButtons from '@/components/ActionButtons'
import GQL from './gql'
import gql from 'graphql-tag'
export default {
  name: 'Creator',

  components: {
    ActionButtons
  },

  props: [],
  data: function() {
    return {
      workflows: [],
      selectedReason: null,
      newTicket: null,
      newTicketTemplate: {
        Parent: null,
        ParentID: null,
        Substatus: 'Creating',
        ServiceID: null
      },
      addresses: [],
      addressSearch: '',
      requireLocation: false,
      services: []
    }
  },
  watch: {
    selectedReason: function() {
      this.resetTicket()

      for (let workflowIndex in this.workflows) {
        if (this.workflows[workflowIndex].id === this.selectedReason.value) {
          let reasons = JSON.parse(this.workflows[workflowIndex].reasons)
          this.newTicket.TicketType = this.workflows[workflowIndex].name
          for (let reasonIndex in reasons) {
            this.requireLocation = reasons[reasonIndex].location
            if (this.requireLocation === false) {
              this.newTicket.Parent = reasons[reasonIndex].defaultParent
              this.newTicket.ParentID = reasons[reasonIndex].defaultParentID
            }
            return
          }
        }
      }

      this.requireLocation = false
    }
  },
  computed: {
    workflowReasons: function() {
      let options = []

      let workFlows = this.workflows

      let classifications = []
      for (let workflowIndex in workFlows) {
        let reasons = JSON.parse(workFlows[workflowIndex].reasons)
        for (let reasonIndex in reasons) {
          if (
            workFlows[workflowIndex].classification &&
            (this.$store.getters.isAdmin ||
              reasons[reasonIndex].staff === false)
          ) {
            if (
              classifications.indexOf(
                workFlows[workflowIndex].classification
              ) === -1
            ) {
              options.push({
                label: workFlows[workflowIndex].classification,
                value: workFlows[workflowIndex].classification,
                classification: workFlows[workflowIndex].classification,
                disable: true
              })
              classifications.push(workFlows[workflowIndex].classification)
            }

            options.push({
              value: workFlows[workflowIndex].id,
              label: reasons[reasonIndex].text,
              classification: workFlows[workflowIndex].classification
            })
          }
        }
      }

      options.sort((a, b) => (a.classification >= b.classification ? 1 : -1))

      return options
    }
  },
  apollo: {
    workflows: {
      query: GQL.workflowReasons,
      skip() {
        return this.workflows.length > 0
      }
    }
  },
  methods: {
    resetTicket: function() {
      this.newTicket = Object.assign({}, this.newTicketTemplate)
    },
    async createTicket() {
      this.loading = true
      await this.$apollo
        .mutate({
          mutation: gql`
            mutation($input: JSON!) {
              createTicket(input: $input) {
                id
              }
            }
          `,
          variables: {
            input: JSON.stringify({
              TicketType: this.newTicket.TicketType,
              Parent: this.newTicket.Parent,
              ParentID: this.newTicket.ParentID,
              ServiceID: this.newTicket.ServiceID,
              Substatus: 'Creating',
              InitialDescription: ''
            })
          }
        })
        .then(data => {
          this.$router.push('/support/' + data.data.createTicket.id)
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
